module.exports = __webpack_public_path__ + "img/7.2f653202.png";